import { runActions } from "../action";
import { IDecorator, INmis } from "../types";
import { Decorator } from "./decorator";
import filterTool from "../util/filterTool";
import Nmis from "../nmis";

export class ComFormDecorator extends Decorator implements IDecorator {
    public static NAME: string = "comForm";

    // 

    /**
     * 获取当前对象实例
     * @returns 
     */
    getInstance() {
        return new ComFormDecorator();
    }

    /**
     * 获取Form组件
     * @param nmis 
     * @returns 
     */
    getFormCompontent(nmis: INmis) {
        if (!filterTool.isNull(nmis.schemaNode)) {
            if (nmis.schemaNode.type == 'Form') {
                return nmis;
            }
        }

        if (filterTool.isNull(nmis.parentNmis)) {
            return undefined;
        }

        return this.getFormCompontent(nmis.parentNmis);
    }

    /**
     * 1. 开始初始化
     */
    beforeInit() {
        // 获取 Form 组件，将Form组件的数据当做 formModel
        const formComponent: INmis | undefined = this.getFormCompontent(this.nmis!);
        if (formComponent) {
            this.addProp('formModel', formComponent.currentData);
        }

        const schema = this.nmis!.copySchemaNode;

        for (var item of schema.props.formItemData) {
            if (!filterTool.isNull(item.slot) && !filterTool.isNull(item.on) && !filterTool.isNull(item.on.btnFun) && typeof (item.slot.btnFun) != 'function') {
                const actions = filterTool.jsonClone(item.on.btnFun.actions);
                item.slot.btnFun = () => {
                    runActions(
                        actions,
                        { field: item.model, openData: this.nmis!.openData },
                        this.nmis!.componentIdMap,
                        this.nmis)
                }
            }
        }
    }

}